export default __webpack_public_path__ + "static/media/anatomy-image-8-444.bb57ca69.png";